import React from 'react'
import { lighten } from 'polished'

// STYLES
import styled from 'styled-components'

const ButtonSmall = ({bgColor, color, size, text, className, clickAction}) => <input type='button' className={className} value={text} onClick={clickAction} />

const ButtonSmallWithStyles = styled(ButtonSmall)`
    background-color: ${(props) => props.bgColor};
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    color: ${(props) => props.color};
    font-family: Dosis;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    outline: none;
    transition: all 0.3s ease;
    border: none;

    &:hover{
        background: ${(props) => lighten(0.05, props.bgColor)};
    }
`

export default ButtonSmallWithStyles



// WEBPACK FOOTER //
// ./src/components/buttonsmall/buttonsmall.component.js